import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper } from './SectionWrapper';
const steps = [{
  num: '1',
  text: 'Descarga la guía y lee el capítulo 1 hoy mismo para entender por qué tus consejos están fallando.'
}, {
  num: '2',
  text: "Aplica la 'Pausa de los 4 Segundos' en la siguiente interacción tensa con tu hijo."
}, {
  num: '3',
  text: 'Usa los Guiones de Rescate para desarmar la siguiente discusión antes de que empiece.'
}];
export function HowItWorksSection() {
  return <SectionWrapper altBg data-id="element-66">
      <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-12 text-center" data-id="element-67">
        Cómo funciona
      </h2>

      <div className="space-y-8 relative before:absolute before:inset-0 before:ml-6 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-subtle before:to-transparent" data-id="element-68">
        {steps.map((step, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.2
      }} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-69">
            <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-cream-alt bg-card text-amber font-heading font-bold text-xl shadow-warm shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-70">
              {step.num}
            </div>
            <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] p-6 rounded-sm bg-card shadow-warm border border-subtle" data-id="element-71">
              <p className="text-secondary font-body text-lg" data-id="element-72">{step.text}</p>
            </div>
          </motion.div>)}
      </div>
    </SectionWrapper>;
}